import { BlockUserUseCase } from '@/data/use-cases/users-use-cases.js';
import { CreateUserUseCase } from '@/data/use-cases/users-use-cases.js';
import { LoadClientOptionsUseCase } from '@/data/use-cases/users-use-cases.js';
import { LoadProjectOptionsUseCase } from '@/data/use-cases/users-use-cases.js';
import { LoadUserAssignmentsUseCase } from '@/data/use-cases/users-use-cases.js';
import { LoadUserByIdUseCase } from '@/data/use-cases/users-use-cases.js';
import { LoadUsersUseCase } from '@/data/use-cases/users-use-cases.js';
import { ResetUserPasswordUseCase } from '@/data/use-cases/users-use-cases.js';
import { SaveUserAssignmentsUseCase } from '@/data/use-cases/users-use-cases.js';
import { UnblockUserUseCase } from '@/data/use-cases/users-use-cases.js';
import { UpdateUserUseCase } from '@/data/use-cases/users-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { UserRepositoryImpl } from '@/infra/repositories/user-repository-impl.js';
import { UserController } from '@/presentation/controllers/user-controller.js';

export const makeUserController = (httpClient: FetchHttpClient): UserController => {
    const repository = new UserRepositoryImpl(httpClient);
    return new UserController(
        new LoadUsersUseCase(repository),
        new LoadUserByIdUseCase(repository),
        new CreateUserUseCase(repository),
        new UpdateUserUseCase(repository),
        new BlockUserUseCase(repository),
        new UnblockUserUseCase(repository),
        new ResetUserPasswordUseCase(repository),
        new LoadUserAssignmentsUseCase(repository),
        new SaveUserAssignmentsUseCase(repository),
        new LoadClientOptionsUseCase(repository),
        new LoadProjectOptionsUseCase(repository)
    );
};
